import { FC, Dispatch } from 'react';
import Selectize, { Item } from 'components/Selectize';
import { Button, Form } from 'react-bootstrap';
import {
  CreateData,
  CreateErrors,
  UpdateData,
  UpdateErrors
} from 'libs/apiClient/admin/educationalBackgroundGroups';

type FormProps = {
  formData: CreateData | UpdateData;
  setFormData: Dispatch<React.SetStateAction<CreateData | UpdateData>>;
  errors: CreateErrors | UpdateErrors;
  universities: Item<number[]>[];
  setUniversities: Dispatch<React.SetStateAction<Item<number[]>[]>>;
  onSubmit: () => void;
}

const EducationalBackgroundGroupForm: FC<FormProps>= (props) => {
  const {
    formData,
    setFormData,
    errors,
    universities,
    setUniversities,
    onSubmit
  } = props;

  const onChange = (value: string, key: 'name'): void => {
    const data = { ...formData }
    data[key] = value;

    setFormData(data);
  }

  const setUniversityIds = (item: Item<number[]>): void => {
    const data = { ...formData }
    const universityIds = item.value;
    data.universityIds = data.universityIds.concat(universityIds)

    setFormData(data);
  }

  const removeUniversityIds = (item: Item<number[]>): void => {
    const data = { ...formData }
    const universityIds = item.value;
    data.universityIds = data.universityIds.filter(universityId => !universityIds.includes(universityId))

    setFormData(data);
  }

  return (
    <Form noValidate>
      <Form.Group controlId='formBasicName'>
        <Form.Label>学歴グループ名</Form.Label>
        <Form.Control
          type='text'
          name="name"
          onChange={ e => onChange(e.currentTarget.value, "name") }
          defaultValue={ formData.name }
          isInvalid={ errors.name?.length > 0 }
        />
        <Form.Control.Feedback type="invalid">
          { errors.name?.map((err, i) => <p key={ `error-name-${i}` }>{ err }</p>) }
        </Form.Control.Feedback>
      </Form.Group>
      <Form.Group controlId='formBasicName'>
        <Form.Label>大学・大学院・短期大学</Form.Label>
        <Selectize
          id={ 'universities' }
          items={ universities }
          setItems={ setUniversities }
          onRemove={ removeUniversityIds }
          onSelect={ setUniversityIds }
          placeholder={ '学校名を入力してください' }
          isInvalid={ errors.universityIds?.length > 0 }
        />
        <Form.Control.Feedback type="invalid">
          { errors.universityIds?.map((err, i) => <p key={ `error-universityIds-${i}` }>{ err }</p>) }
        </Form.Control.Feedback>
      </Form.Group>

      <Button type="button" onClick={ onSubmit } variant='outline-success'>
        登録
      </Button>
    </Form>
  )
}

export default EducationalBackgroundGroupForm;
